import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Box = styled.div`
  position: absolute;
  left: calc(50% - 65px);
  top: calc(50% - 149px);

  @media ${device.mobileS} and ${device.tablet} {
    top: calc(50% - 60px);
    left: calc(50% - 25px);
  }

  @media ${device.laptop} and ${device.laptopMax} {
    top: calc(50% - 111px);
    left: calc(50% - 44px);
  }
  @media (min-width: 1025px) {
    top: calc(45% - 136px);
    left: calc(50% - 51px);
  }
  @media${device.tv} {
    top: calc(50% - 167px);
    left: calc(50% - 82px);
  }

  @media${device.tvL} {
    top: calc(50% - 200px);
    left: calc(50% - 130px);
  }
  @media${device.uhd} {
    top: calc(50% - 335px);
    left: calc(50% - 160px);
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 60%;
  left: 50%;

  @media ${device.laptop} and ${device.laptopMax} {
    top: 60%;
    left: 50%;
  }

  @media (min-width: 1025px) {
    top: 61%;
    left: 49%;
  }

  @media${device.tv} {
    top: 57%;
    left: 49%;
  }

  @media${device.tvL} {
    top: 57%;
    left: 53%;
  }

  @media${device.uhd} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(320px);
  }
`;

export const CategoryDiv = styled.div`
  position: absolute;

  transform: rotate(${(props) => props.$degCalc * props.$index}deg)
    translateX(130px);
  transition: 1s ease;

  @media ${device.mobileS} and ${device.tablet} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(50px);
  }

  @media ${device.laptop} and ${device.laptopMax} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(100px);
  }

  @media (min-width: 1025px) {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(120px);
  }

  @media${device.tv} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(160px);
  }

  @media${device.tvL} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(180px);
  }

  @media${device.uhd} {
    transform: rotate(${(props) => props.$degCalc * props.$index}deg)
      translateX(320px);
  }
`;

export const Content = styled.div`
  position: absolute;
  top: calc(50% - 13px);
  left: calc(50% - 7px);
  transform: rotate(-120deg);

  @media${device.tv} {
    top: calc(50%);
    left: calc(50% - 20px);
  }

  @media${device.tvL} {
    top: calc(50% - 10px);
    left: calc(50% - 60px);
  }
`;
